var map = {
	"./logo-alphabet.svg": 607,
	"./logo-amazon-2.svg": 608,
	"./logo-amazon.svg": 693,
	"./logo-azercell.svg": 694,
	"./logo-bank-of-america.svg": 695,
	"./logo-barclays.svg": 696,
	"./logo-bbc.svg": 697,
	"./logo-bloomberg.svg": 609,
	"./logo-bnp-paribas.svg": 698,
	"./logo-booking.svg": 699,
	"./logo-citibank.svg": 700,
	"./logo-cnbc.svg": 610,
	"./logo-cnbc2.svg": 701,
	"./logo-coca-cola-auto.svg": 606,
	"./logo-coca-cola-white.svg": 1607,
	"./logo-coca-cola.svg": 702,
	"./logo-deloitte.svg": 703,
	"./logo-experian.svg": 704,
	"./logo-facebook.svg": 705,
	"./logo-forbes.svg": 611,
	"./logo-g.svg": 1608,
	"./logo-goldman-sachs-new.svg": 706,
	"./logo-goldman-sachs.svg": 1457,
	"./logo-google-new.svg": 707,
	"./logo-google.svg": 708,
	"./logo-h.svg": 709,
	"./logo-henkel.svg": 710,
	"./logo-hsbc-new.svg": 711,
	"./logo-hsbc.svg": 1455,
	"./logo-ikea-new.svg": 712,
	"./logo-ikea.svg": 1609,
	"./logo-infineon.svg": 713,
	"./logo-instagram-icon.svg": 604,
	"./logo-instagram.svg": 714,
	"./logo-jp-morgan.svg": 715,
	"./logo-jti.svg": 716,
	"./logo-linkedin.svg": 717,
	"./logo-meta-new.svg": 603,
	"./logo-meta.svg": 1459,
	"./logo-morgan-stanley-new.svg": 718,
	"./logo-morgan-stanley.svg": 1456,
	"./logo-netflix.svg": 1453,
	"./logo-oracle.svg": 612,
	"./logo-paypal.svg": 719,
	"./logo-pwc-new.svg": 605,
	"./logo-pwc.svg": 1610,
	"./logo-spotify.svg": 1454,
	"./logo-tesla.svg": 720,
	"./logo-usa-today.svg": 613,
	"./logo-visa.svg": 721,
	"./logo-walmart.svg": 614,
	"./logo-wsj.svg": 615,
	"./logo-youtube.svg": 722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1199;